import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { Box } from "@mui/material";
import { useCallback } from "react";
import styles from "../PricingDialog.module.scss";

export const SortableColumn = <T extends string>(props: {
  column: T;
  label: string;
  currentSortColumn: T | undefined;
  currentSortDirection: "asc" | "desc" | undefined;
  onSortClick: (column: T, sortDirection: "asc" | "desc") => void;
}) => {
  const {
    column,
    label,
    currentSortColumn,
    currentSortDirection,
    onSortClick
  } = props;

  const handleSort = useCallback(
    (column: T) => {
      if (currentSortColumn === column) {
        onSortClick(column, currentSortDirection === "asc" ? "desc" : "asc");
      } else {
        onSortClick(column, "asc");
      }
    },
    [currentSortColumn, currentSortDirection, onSortClick]
  );

  return (
    <Box onClick={() => handleSort(column)} className={styles.sortable}>
      {label}{" "}
      {currentSortColumn === column ? (
        currentSortDirection === "asc" ? (
          <ArrowDropUpIcon className={styles.icon} />
        ) : (
          <ArrowDropDownIcon className={styles.icon} />
        )
      ) : null}
    </Box>
  );
};
